import React from "react";
import MuiUploader from "./../components/basicComponent/MuiUploader";
import MuiButton from "./../components/basicComponent/MuiButton";
import { MuiInput } from "./../components/basicComponent/MuiInput";
import MuiSearchSelect from "./../components/basicComponent/MuiSearchSelect";
import Header from "./../sharedScreens/Header";
import SideMenu from "./../sharedScreens/menuItems/SideMenu";
import MuiDatePicker from "./../components/basicComponent/MuiDatePicker";

const PendingAgentRequest = () => {
  return (
    <>
      <div className="grow">
        <SideMenu />
        <div className="wrapper flex grow flex-col">
          <Header />
          <main className="grow content" id="content" role="content">
            <div className="container-fixed">
              <div className="card-header mb-1 ">
                <h3 className="card-title titlecolorr">
                  Pending Customer Request
                </h3>
              </div>
              <div className="card">
                <div className="row">
                  <div className="card-body">
                    <div className="col-md-12">
                      <div className="row mt-3">
                        <div className="col-md-4 mb-3">
                          <MuiDatePicker
                          label="From Date"
                            value={null}
                            onChange={function (date: string): void {
                              throw new Error("Function not implemented.");
                            }}
                          />
                        </div>

                        <div className="col-md-4 mb-3">
                        <MuiDatePicker
                        label="To Date"
                            value={null}
                            onChange={function (date: string): void {
                              throw new Error("Function not implemented.");
                            }}
                          />
                        </div>

                        <div className="col-md-4 mb-3">
                        <div className="user-button w-full">
                        
                        <MuiButton
                          className="get-btn"
                          label="GET"
                          onClick={() => {}}
                          type="submit"
                        />
                        <MuiButton className="clear-btn" label="Clear" />
                      </div>
                        </div>
                      </div>

                    
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </main>
        </div>
      </div>
    </>
  );
};

export default PendingAgentRequest;
